import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LocationDataService } from '../../../services/location-data.service';

@Component({
  selector: 'lib-ds-state-province-dropdown',
  templateUrl: './state-province-dropdown.component.html',
  styleUrls: ['./state-province-dropdown.component.scss']
})
export class DsStateProvinceDropdownComponent implements OnInit, OnChanges {
  @Input() control!: FormControl;
  @Input() country: string = '';
  @Input() placeholder: string = 'Select State/Province';
  @Input() required: boolean = false;
  @Input() label: string = '';
  @Input() errorMessage: string = '';
  @Input() showError: boolean = false;
  @Input() showLabel: boolean = true;
  @Input() id: string = '';
  @Input() submitted: boolean = false;
  @Output() selectionChange = new EventEmitter<string>();

  states: string[] = [];
  fieldId: string = '';

  constructor(private locationDataService: LocationDataService) {}

  ngOnInit() {
    this.generateFieldId();
    this.updateStates();
  }

  ngOnChanges() {
    this.updateStates();
  }

  private generateFieldId(): void {
    if (!this.id) {
      this.fieldId = `ds-state-province-${Math.random().toString(36).substring(2, 9)}`;
    } else {
      this.fieldId = this.id;
    }
  }

  get computedCssClass(): string {
    let classes = 'form-select';

    if (this.showError) {
      classes += ' is-invalid';
    }

    return classes;
  }

  get shouldShowError(): boolean {
    if (this.showError) {
      return true;
    }
    
    if (this.control && this.control.invalid) {
      return this.control.touched || this.control.dirty || this.submitted;
    }
    
    return false;
  }

  private updateStates() {
    this.states = this.locationDataService.getStatesByCountry(this.country);
  }

  onSelectionChange(event: any) {
    this.selectionChange.emit(event.target.value);
  }
}

